routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.reportOrders', {
      url: "reportes/pedidos",
      template: `<report-orders sh-ctrl="shCtrl"></report-orders>`
    });
}

export default routesConfig;



// WEBPACK FOOTER //
// ./www/components/reports/orders/orders.config.js